// extracted by mini-css-extract-plugin
export default {"root":"ActiveLabel_root__H+pYh"};